import React, { useContext } from "react";
import t from "module/translations";
import TrainingCustomContext from "module/trainingCustom/context/TrainingCustomContext";
import { TrainingCustomInterface } from "module/trainingCustom/types";
import XLabelField from "component/labelField/XLabelField";

const TrainingCustomNameFieldContainer: React.FC = () => {
  const { entity } = useContext(TrainingCustomContext);
  const { name } = entity as TrainingCustomInterface;

  return (
    <XLabelField
      {...{
        caption: t.competencyManagement.trainingCustom.nameText,
        label: name,
      }}
    />
  );
};

export default React.memo(TrainingCustomNameFieldContainer);
